import make, { Enum } from '@xaamin/enum';

class PrefacturaStatus extends Enum {

  name = 'PrefacturaStatus';

  enum = {
    'pending': 0,
    'success': 1,
    'cancelled': -1,
  }

}

export default make(PrefacturaStatus);